import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EpdV2Service {
  protected httpClient = inject(HttpClient);

  fetchStandardsList() {
    return this.httpClient
      .get('/api/v1/epd/v2/available_standards')
      .pipe(map((res: { available_standards: any[] }) => res.available_standards ?? []));
  }

  fetchLanguagesList(standard: string) {
    return this.httpClient.get(`/api/v1/epd/v2/available_languages?standard=${standard}`).pipe(
      map((res: { available_languages: any[] }) => {
        return res.available_languages?.map((language) => ({ ...language, text: language.value })) ?? [];
      })
    );
  }


  fetchData(rid: string, pcr_rid?: string, standard?: string) {
    let params = new HttpParams();
    if (pcr_rid) params = params.append('pcr_rid', pcr_rid.replace('#', ''));
    if (standard) params = params.append('standard', standard);

    return this.httpClient.get(`/api/v1/epd/v2/${rid}/data`, { params });
  }

  fetchV1Data(rid: string, standard: string) {
    return this.httpClient.get(`/api/v1/epd/${rid}?methodology=${standard}`);
  }

  fetchMaterialBreakdown(rid: string, layerRid: string) {
    return this.httpClient.get(`/api/v1/epd/${rid}/material_breakdown?layer_rid=${layerRid}`);
  }

  fetchLogoImage(url) {
    return this.httpClient.get(url, {
      responseType: 'blob',
      headers: { 'Cross-Origin-Resource-Policy': 'cross-origin' }
    });
  }

  submitData(rid: string, payload: any) {
    return this.httpClient.post(`/api/v1/epd/v2/${rid}/edit_properties`, payload);
  }

  downloadAdditionalExports(url) {
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    return this.httpClient.get(normalizedUrl, { responseType: 'blob', observe: 'response' });
  }
}
